/**
 * Created by Bart Decorte
 * Date: 2019-07-22
 * Time: 14:24
 */

const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

function modifierState(ev) {
  if (isMac) {
    return ev.metaKey;
  }

  return ev.ctrlKey;
}

export { isMac, modifierState };


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/os.js